module.exports = __webpack_public_path__ + "static/media/halfcircle_blue.bc6b5ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/halfcircle_blue.jpg
// module id = 965
// module chunks = 1